import CleverTap from 'clevertap-web-sdk';
import { useMediaQuery } from '@mantine/hooks';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { IEventProperties, IEventPropertiesCommon } from "./types";

const useCleverTapEvents = () => {
  const isMobileDevice = useMediaQuery('(max-width: 576px)');
  const source = isMobileDevice ? "mobile" : "web";
  const timeStamp = Date.now().toString();
  const mobileNumber = useSelector((state:RootState) => state.account.mobileNumber)
  const mobile = mobileNumber || 0;

  const identifyUserOnClevertap = (id: string) => {
    CleverTap.onUserLogin.push({
      Site: {
        Identity: id,
        'MSG-email': false,
        'MSG-push': false,
        'MSG-sms': false,
        'MSG-whatsapp': false,
      },
    });
  };

  const fireEvent = (eventName:string, eventProperties:IEventProperties & IEventPropertiesCommon) => {
    if (eventName) {
      const property: Record<string, any> = {};
      Object.entries(eventProperties).forEach(([key, value]) => {
        property[key] = JSON.stringify(value);
      });
      CleverTap.event.push(eventName, property);
    }
  };

  const TriggerEvent = (eventName: string, extraParams: IEventProperties) => {
    fireEvent(eventName, {
      source,
      timeStamp,
      mobile,
      ...extraParams,
    })
  }

  return { TriggerEvent, identifyUserOnClevertap };
}

export default useCleverTapEvents;
